import gql from 'graphql-tag';
import { query } from '../../client';
import { ORDER_FIELDS } from '../fragments/ordersFields';
import { INVENTORY_FIELDS } from '../fragments/inventoryFields';
const OrderQuery = gql `
  ${ORDER_FIELDS}
  ${INVENTORY_FIELDS}

  query OrderQuery($orderId: String!) {
    order(orderId: $orderId)
      @rest(type: "OrderResult", path: "orders/{args.orderId}") {
      data @type(name: "Order") {
        ...OrderFields
        products {
          id
          name
          type
          updatedAt
          createdAt
          inventory @type(name: "Inventory") {
            ...InventoryFields
          }
        }
        extras {
          next {
            membershipId
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`;
export function getOrder(orderId) {
    return query({
        query: OrderQuery,
        variables: { orderId },
    });
}
export default getOrder;
